// extracted by mini-css-extract-plugin
export const container = "Why-module--container--3h7zv";
export const items = "Why-module--items--1XHkb";
export const item = "Why-module--item--1LdV3";
export const title = "Why-module--title--146Os";
export const subTitle = "Why-module--subTitle--1Rwvh";
export const content = "Why-module--content--dMKQj";